import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { CurrentUserService, CurrentUser } from "../services/current-user.service";

@Injectable()
export class CurrentUserResolver implements Resolve<CurrentUser> {

    constructor(private currentUserService: CurrentUserService) { }

    resolve(): Observable<CurrentUser> {
        return this.currentUserService.get();
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/resolvers/current-user.resolver.ts